import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { BaseRequestOptions, HttpModule, Http } from '@angular/http';
//import { MockBackend } from '@angular/http/testing';
import { AlertComponent } from './_directives/alert.component';
import { LogoutComponent } from './logout/logout.component';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth-guards/auth.guard';
import { NoGuard } from '@auth-guards/no.guard';
import { AuthComponent } from "@auth/auth.component";
import { AuthRoutingModule } from "@auth/auth-routing.routing";

@NgModule({
  declarations: [
    AuthComponent,
    AlertComponent,
    LogoutComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
  //  HttpModule,
    AuthRoutingModule,
    RouterModule
  ],
  providers: [
    AuthGuard,
    NoGuard,
    AlertService,
    AuthenticationService,
    UserService,
    // api backend simulation
    //MockBackend,
    //BaseRequestOptions
  ],
  entryComponents: [AlertComponent],
})

export class AuthModule {
}
